export default "__VITE_ASSET__V$XV1X$T__"